import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";

const ITEMS = [
  {
    id: 9,
    title: "Smart Classroom",
    image: "/images/services/p1.png",
    modalImages: [
      "/images/services/paket1.png",
    ], 
    description:
      "Rangkaian perangkat presentasi & kolaborasi interaktif untuk pembelajaran modern.",
    slug: "classroom",
  },
  {
    id: 10,
    title: "Smart Meeting Room",
    image: "/images/services/p2.png",
    modalImages: [
      "/images/services/paket2.png",
    ],
    description:
      "VC, audio processing, dan kontrol terpadu agar meeting efisien & bebas ribet.",
    slug: "meetingroom",
  },
  {
    id: 11,
    title: "Smart Auditorium",
    image: "/images/services/p3.png",
    modalImages: [
      "/images/services/paket3.png",
    ],
    description:
      "Sistem pro-AV skala besar: routing, scaling, dan multi-source display yang stabil.",
    slug: "auditorium",
  },
];

export default function ProductCustomize() {
  const navigate = useNavigate();

  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const active = useMemo(() => ITEMS[activeIndex] ?? null, [activeIndex]);

  const openModal = useCallback((idx) => {
    setActiveIndex(idx);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => setIsOpen(false), []);

  useEffect(() => {
    if (!isOpen) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = original;
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) return;
    const onKey = (e) => {
      if (e.key === "Escape") closeModal();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [isOpen, closeModal]);

  const closeBtnRef = useRef(null);
  useEffect(() => {
    if (isOpen) closeBtnRef.current?.focus();
  }, [isOpen]);

  return (
    <main className="bg-[#F3F3F3] text-[#0B132A] min-h-screen">
      <div className="w-full bg-white/80 backdrop-blur border-b border-gray-200">
        <div className="max-w-7xl mx-auto h-14 px-4 sm:px-6 md:px-8 xl:px-12 flex items-center gap-4">
          <button
            onClick={() => navigate(-1)}
            className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-gray-100 hover:bg-gray-200 text-sm transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
            aria-label="Kembali"
          >
            <BsArrowLeft size={16} />
            Kembali
          </button>
          <span className="text-gray-400" aria-hidden> / </span>
          <span className="text-sm text-gray-600">Services</span>
          <span className="text-gray-400" aria-hidden> / </span>
          <span className="text-sm font-medium">Product Customize</span>
        </div>
      </div>

      <section className="py-10 md:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 xl:px-12">
          <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-center">
            <div data-aos="fade-right" data-aos-duration="800" className="order-1">
              <div className="rounded-2xl overflow-hidden bg-white border border-gray-200 shadow-sm">
                <div className="relative w-full aspect-[16/9]">
                  <img
                    src="/images/services/custom.png"
                    alt="Product Customize"
                    className="absolute inset-0 w-full h-full object-cover"
                    loading="lazy"
                    decoding="async"
                    onError={(e) => { e.currentTarget.src = "/images/placeholders/solution.png"; }}
                  />
                </div>
              </div>
            </div>

            <div data-aos="fade-left" data-aos-duration="800" className="order-2">
              <p className="text-emerald-600 font-semibold tracking-wide">Product Customize</p>
              <h1 className="mt-2 text-2xl md:text-4xl font-semibold leading-snug">
                Solusi AV yang Disesuaikan untuk Bisnis Anda
              </h1>
              <p className="mt-4 text-[15px] md:text-base text-gray-700 leading-7">
                Setiap perusahaan memiliki kebutuhan yang berbeda. Melalui layanan
                Kustomisasi Produk, kami menghadirkan solusi audiovisual yang dapat
                disesuaikan secara menyeluruh mulai dari perangkat, Control Interactive,
                hingga workflow operasional. Hasilnya, sistem yang Anda gunakan tidak
                hanya fungsional dan efisien, tetapi juga selaras dengan identitas serta
                budaya kerja perusahaan.
              </p>

              <div className="mt-8 flex flex-wrap gap-3">
                <Link
                  to="/request"
                  className="inline-flex items-center gap-2 rounded-full border border-emerald-600 px-5 py-2.5 text-sm font-medium text-emerald-700 hover:text-white hover:bg-emerald-600 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500 focus-visible:ring-offset-2 focus-visible:ring-offset-[#F3F3F3]"
                >
                  Ajukan Request
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 12h14" /><path d="m12 5 7 7-7 7" />
                  </svg>
                </Link>
                <a
                  href="https://wa.me/6289507085550"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 rounded-full bg-white px-5 py-2.5 text-sm font-medium text-gray-700 border border-gray-300 hover:bg-gray-100 transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-emerald-500"
                >
                  Chat via WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-10 md:py-12 bg-[#F3F3F3]">
        <div className="w-full max-w-7xl mx-auto px-4 lg:px-16 pb-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
            {ITEMS.map((item, i) => (
              <button
                key={item.id}
                type="button"
                onClick={() => openModal(i)} // <-- buka lightbox
                aria-label={`Lihat detail ${item.title}`}
                className="group relative rounded-xl overflow-hidden border bg-white shadow-lg transition-all hover:shadow-xl focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#2E7462] focus-visible:ring-offset-white"
                data-aos="fade-up"
                data-aos-duration="800"
                data-aos-delay={i * 120}
              >
                <div className="relative w-full aspect-[4/3]">
                  <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    decoding="async"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-[1.04]"
                    onError={(e) => { e.currentTarget.src = "/images/placeholders/solution.png"; }}
                    sizes="(min-width:1024px) 33vw, (min-width:640px) 50vw, 100vw"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-black/25 to-transparent" />
                </div>

                <div className="pointer-events-none absolute inset-0 flex items-end">
                  <div className="w-full p-5 md:p-6">
                    <h3 className="text-white text-lg md:text-xl font-semibold drop-shadow-sm">
                      {item.title ?? "Untitled"}
                    </h3>
                  </div>
                </div>
              </button>
            ))}
          </div>
        </div>
      </section>

      {isOpen && active && (
        <div
          className="fixed inset-0 z-[999]"
          role="dialog"
          aria-modal="true"
          aria-labelledby="lb-title"
        >
          <div
            className="absolute inset-0 bg-black/80 backdrop-blur-[2px]"
            onClick={closeModal}
          />

          <div className="absolute inset-0 flex items-center justify-center p-3 md:p-6">
            <div className="relative bg-white rounded-2xl overflow-hidden shadow-2xl max-w-[95vw] max-h-[95vh] flex items-center justify-center">
              <button
                ref={closeBtnRef}
                type="button"
                onClick={closeModal}
                aria-label="Tutup"
                className="absolute top-3 right-3 z-10 h-10 w-10 rounded-full bg-black/60 text-white flex items-center justify-center hover:bg-black/70 focus:outline-none focus:ring-2 focus:ring-black/40"
              >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                </svg>
              </button>

              <figure className="flex flex-col items-center justify-center w-full h-full">
                <img
                  src={(active.modalImages && active.modalImages[0]) || active.image}
                  alt={active.title}
                  className="max-w-full max-h-[90vh] object-contain"
                  loading="lazy"
                  decoding="async"
                  onError={(e) => { e.currentTarget.src = "/images/placeholders/solution.png"; }}
                />
              </figure>
            </div>
          </div>
        </div>
      )}
    </main>
  );
}
